// Gestione del consenso cookie (GDPR) — necessari, analytics, marketing.
const KEY = "sc_cookie_consent";
export const CONSENT_EVENT = "sc-consent-changed";
export const OPEN_PREFS_EVENT = "sc-open-cookie-preferences";

export function getConsent() {
  try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
}

export function saveConsent(c) {
  const val = {
    necessary: true,
    analytics: !!c.analytics,
    marketing: !!c.marketing,
    ts: new Date().toISOString(),
  };
  try { localStorage.setItem(KEY, JSON.stringify(val)); } catch { /* noop */ }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: val }));
  return val;
}

export function hasConsent(category) {
  const c = getConsent();
  if (!c) return category === "necessary";
  return !!c[category];
}

export function openCookiePreferences() {
  window.dispatchEvent(new CustomEvent(OPEN_PREFS_EVENT));
}
